import React, { Fragment } from 'react';
import {Redirect} from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoutes = props => {
    const isAuth = useSelector(state=> state.auth.isAuth);

    return (
        <Fragment>
            {isAuth ? props.children : <Redirect to="/login" />}
        </Fragment>
    );
}
export default PrivateRoutes;